/**
 * @file Anything that can run on every page
 */

import vHeader from '../components/header/header';
import vNewsletterTrigger from '../components/newsletter-trigger/newsletter-trigger';
import vNewsletterModal from '../components/newsletter-modal/newsletter-modal';
import vShareModal from '../components/share-modal/share-modal';

/**
 * Global functions
 *
 * Runs component js and any global tasks
 */
const vGlobal = () => {
	vHeader();
	vShareModal();
	vNewsletterTrigger();
	vNewsletterModal();

	const selects = document.querySelectorAll('select');
	[...selects].forEach((select) => {
		const selectParent = select.parentNode;
		if (selectParent.classList.contains('v-form__select')) {
			return;
		}

		const wrapper = document.createElement('span');
		const arrow   = document.createElement('span');
		wrapper.classList.add('v-form__select');
		arrow.classList.add('v-form__select-arrow');
		selectParent.insertBefore(wrapper, select);
		wrapper.appendChild(select);
		wrapper.appendChild(arrow);
		select.classList.add('v-form__select-field');
	});

	const fillable = document.querySelectorAll('.v-form__fillable');
	[...fillable].forEach((i) => {
		i.addEventListener('focusout', () => {
			if (i.value) {
				i.classList.add('v-form__fillable--filled');
			} else {
				i.classList.remove('v-form__fillable--filled');
			}
		});
	});

	// Animate Favicon
	const colors = ['blue', 'green', 'pink'];
	let colorIndex = 0;

	setInterval(() => {
		colorIndex = (colorIndex + 1) % 3;

		const favicons = document.querySelectorAll('[rel="icon"], [rel="apple-touch-icon"]');
		favicons.forEach((favicon) => {
			favicon.setAttribute('href', `${wpPostData.themeUrl}/favicon/color-changing/favicon-${colors[colorIndex]}.png`);
		});
	}, 1500);

	/**
	 * Global Window Load
	 *
	 * Runs polyfills on page load
	 */
	async function onWindowLoad() {
		const body = document.querySelector('body');
		if (!body.classList.contains('admin-bar')) {
			const { listen } = await import(/* webpackExports: "listen" */ 'quicklink');

			listen({
				ignores: [
					(url) => {
						const cleanUrl = url.replace(/#.*/, '');
						return cleanUrl === window.location.href;
					},
					/.*\/wp-admin\/.*/,
					/.*\.zip/,
				],
			});
		}
	}

	if (document.readyState === 'complete') {
		onWindowLoad();
	} else {
		window.addEventListener('load', onWindowLoad);
	}
};

if (document.readyState !== 'loading') {
	vGlobal();
} else {
	document.addEventListener('DOMContentLoaded', vGlobal);
}
